import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Card } from '../common/Card';
import { Button } from '../common/Button';
import { useAuth } from '../../context/AuthContext';

export const EmailVerification = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { verifyEmail } = useAuth();
    const [status, setStatus] = useState({
        isLoading: true,
        error: null,
        success: false
    });

    useEffect(() => {
        const handleVerification = async () => {
            try {
                const oobCode = searchParams.get('oobCode');
                if (!oobCode) {
                    throw new Error('No verification code provided');
                }

                await verifyEmail(oobCode);
                setStatus({
                    isLoading: false,
                    error: null,
                    success: true
                });
            } catch (error) {
                setStatus({
                    isLoading: false,
                    error: error.message,
                    success: false
                });
            }
        };

        handleVerification();
    }, [searchParams, verifyEmail]);

    const handleContinue = () => {
        navigate('/login', {
            replace: true,
            state: {
                message: 'Email verified successfully! You can now log in.',
                type: 'success'
            }
        });
    };

    return (
        <Card className="max-w-md mx-auto p-8 mt-8">
            <h2 className="text-2xl font-bold text-center mb-6">Email Verification</h2>
            
            {status.isLoading && (
                <div className="text-center">
                    <p className="text-gray-600">Verifying your email...</p>
                </div>
            )}

            {status.error && (
                <div className="bg-red-50 text-red-500 p-4 rounded-md mb-4">
                    <p>{status.error}</p>
                    <Button 
                        onClick={() => navigate('/login')}
                        className="mt-4"
                    >
                        Return to Login
                    </Button>
                </div>
            )}

            {status.success && (
                <div className="text-center">
                    <div className="bg-green-50 text-green-600 p-4 rounded-md mb-4">
                        <p>Your email has been verified successfully!</p>
                    </div>
                    <Button onClick={handleContinue}>
                        Continue to Login
                    </Button>
                </div>
            )}
        </Card>
    );
};